import { twJoin } from 'tailwind-merge';

import { Badge, BadgeText } from '@/components/ui/badge';
import { TREATMENT_SUPPORT_LABEL } from '@/constants/medicalOnDemand';

type ProductSupportBadgeProps = {
  size?: 'sm' | 'md';
  className?: string;
  textClassName?: string;
};

export function ProductSupportBadge({
  size = 'sm',
  className,
  textClassName,
}: ProductSupportBadgeProps) {
  return (
    <Badge
      size={size}
      className={twJoin(
        size === 'sm' ? 'border border-primary-100 bg-primary-50' : 'bg-primary-50',
        className
      )}>
      <BadgeText
        className={twJoin(
          size === 'sm' ? 'text-[10px] uppercase text-primary-700' : 'text-xs text-primary-700',
          textClassName
        )}>
        {TREATMENT_SUPPORT_LABEL}
      </BadgeText>
    </Badge>
  );
}
